export default "__VITE_ASSET__a25ceaf9__"